/**
 * Shared NavHeader Component Types and Constants
 * Used by NavHeader-Level0, NavHeader-Level1, and NavHeader-Level2
 */

// Attribute names
export const ATTRIBUTES = {
  HEADER_CONTENT_WIDTH: 'header-content-width',
} as const

// Attribute values
export const CONTENT_WIDTH_VALUES = {
  CONTAINED: 'contained',
  FULL_WIDTH: 'full-width',
} as const

export type ContentWidthValue = typeof CONTENT_WIDTH_VALUES[keyof typeof CONTENT_WIDTH_VALUES]
